module.exports = __webpack_public_path__ + "img/amoun.663cf46b.jpg";